import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Card } from "@/components/ui/card";
import { RefreshCw, AlertCircle, CheckCircle2 } from "lucide-react";
import { API } from "@/contexts/AuthContext";

const CustomerBookNowPage = () => {
  const { bookToken } = useParams();
  const [status, setStatus] = useState('loading'); // loading, success, error, already_processed
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  
  useEffect(() => {
    const submitBookRequest = async () => {
      try {
        const response = await axios.post(`${API}/follow-ups/book/${bookToken}`);
        if (response.data.success) {
          setStatus('success');
          setData(response.data);
        } else {
          setStatus('already_processed');
          setData(response.data);
        }
      } catch (err) {
        setStatus('error');
        setError(err.response?.data?.detail || 'Invalid booking link');
      }
    };
    
    if (bookToken) {
      submitBookRequest();
    }
  }, [bookToken]);
  
  if (status === 'loading') {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
        <Card className="w-full max-w-md text-center p-8">
          <RefreshCw className="w-12 h-12 text-blue-600 animate-spin mx-auto mb-4" />
          <p className="text-slate-600">Processing your request...</p>
        </Card>
      </div>
    );
  }
  
  if (status === 'error') {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
        <Card className="w-full max-w-md text-center p-8">
          <AlertCircle className="w-16 h-16 text-red-500 mx-auto mb-4" />
          <h1 className="text-2xl font-bold text-slate-900 mb-2">Link Not Valid</h1>
          <p className="text-slate-600 mb-6">{error}</p>
          <p className="text-sm text-slate-500">
            Please call us directly to arrange your booking.
          </p>
        </Card>
      </div>
    );
  }
  
  if (status === 'already_processed') {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
        <Card className="w-full max-w-md text-center p-8">
          <CheckCircle2 className="w-16 h-16 text-amber-500 mx-auto mb-4" />
          <h1 className="text-2xl font-bold text-slate-900 mb-2">Already Processed</h1>
          <p className="text-slate-600 mb-6">{data?.message}</p>
          <p className="text-sm text-slate-500">
            If you haven't heard from us, please call directly.
          </p>
        </Card>
      </div>
    );
  }
  
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <Card className="w-full max-w-md text-center p-8">
        <CheckCircle2 className="w-16 h-16 text-green-500 mx-auto mb-4" />
        <h1 className="text-2xl font-bold text-slate-900 mb-2">Thank You!</h1>
        <p className="text-slate-600 mb-4">
          {data?.message || "Our team will call you shortly to arrange your booking."}
        </p>
        {data?.vehicle_reg && (
          <p className="text-sm text-slate-500">
            Vehicle: <span className="font-mono font-bold">{data.vehicle_reg}</span>
          </p>
        )}
        <div className="mt-8 pt-6 border-t border-slate-200">
          <p className="text-xs text-slate-400">
            Powered by Yestimate
          </p>
        </div>
      </Card>
    </div>
  );
};

export default CustomerBookNowPage;
